import 'core-js/stable';
import DealerDetails from './details.js';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('#dealer-details').forEach((el) => new DealerDetails(el));
});
